export const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
};

export const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.2,
        },
    },
};

// New simplified variants for the 3-effect system
export const staggeredContainerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.3,
            ease: "easeOut"
        }
    }
};

// Effect 1: Slide up from bottom
export const slideUpVariants = {
    hidden: { 
        opacity: 0, 
        y: 30 
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            ease: "easeOut"
        }
    }
};

// Effect 2: Slide in from left
export const slideLeftVariants = {
    hidden: { 
        opacity: 0, 
        x: -40 
    },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 0.6,
            ease: "easeOut"
        }
    }
};

// Effect 3: Slide in from right
export const slideRightVariants = {
    hidden: { 
        opacity: 0, 
        x: 40 
    },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 0.6,
            ease: "easeOut"
        }
    }
};

// Simple page animation - one effect per page
export const pageVariants = {
    hidden: { 
        opacity: 0, 
        y: 50 
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.8,
            ease: "easeOut"
        }
    }
};

// Effect 4: Slide from left and going up (separate movements)
export const slideLeftUpVariants = {
    hidden: { 
        opacity: 0, 
        x: -40,
        y: 40  // starts from below
    },
    visible: {
        opacity: 1,
        x: 0,   // slides to center horizontally
        y: 0,   // moves up to final position
        transition: {
            duration: 0.6,
            ease: "easeOut"
        }
    }
};

// Effect 5: Slide from right only
export const slideFromRightVariants = {
    hidden: { 
        opacity: 0, 
        x: 40,
        filter: "blur(10px)"
    },
    visible: {
        opacity: 1,
        x: 0,
        filter: "blur(0px)",
        // transition: {
        //     duration: 0.6,
        //     ease: "easeOut"
        // }
    }
};

// Effect 6: Coming from below with blur
export const slideFromBelowVariants = {
    hidden: { 
        opacity: 0, 
        y: 30,
        // filter: "blur(10px)"
    },
    visible: {
        opacity: 1,
        y: 0,
        // filter: "blur(0px)",
        // transition: {
        //     ease: "easeOut"
        // }
    }
};

